'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _ = require('lodash');
var RecommendationFilterService = function RecommendationFilterService(faresOptimizerConstants) {
  var FILTER_MODES = {
    INCLUSIVE: 'INCLUSIVE',
    EXCLUSIVE: 'EXCLUSIVE'
  };
  function buildFilter(mode, filterArgs) {
    return {
      mode: mode,
      filterArgs: filterArgs
    };
  }
  function optimizeFilters(filters) {
    var ignoreExlucsiveFiltering = [faresOptimizerConstants.AUTO_APPROVAL_STOPPED_KEY, faresOptimizerConstants.ACTION_CODE_KEY];
    return _.chain(filters).reduce(function (result, item, key) {
      if (!item.selected) {
        result[key] = buildFilter(FILTER_MODES.INCLUSIVE, []);
      } else if (item.selected.length !== item.available.length) {
        if (item.selected.length > item.available.length / 2 && ignoreExlucsiveFiltering.indexOf(key) === -1) {
          result[key] = buildFilter(FILTER_MODES.EXCLUSIVE, _.difference(item.available, item.selected));
        } else if (key === faresOptimizerConstants.ACTION_CODE_KEY) {
          var selected = [].concat((0, _toConsumableArray2["default"])(item.selected), ['Nil']);
          result[key] = buildFilter(FILTER_MODES.INCLUSIVE, _.clone(selected));
        } else {
          result[key] = buildFilter(FILTER_MODES.INCLUSIVE, _.clone(item.selected));
        }
      }
      return result;
    }, {}).value();
  }
  function filterByProperty(item, filter, property) {
    if (filter) {
      var value = item[property] === '–' ? '-' : item[property];
      if (filter.filterArgs.includes('None')) {
        filter.filterArgs[filter.filterArgs.indexOf('None')] = '-';
      }
      var itemFound = _.isArray(value) ? _.isEmpty(_.intersection(filter.filterArgs, value)) : filter.filterArgs.indexOf(value) === -1;
      return filter.mode === FILTER_MODES.EXCLUSIVE ? itemFound : !itemFound;
    }
    return true;
  }
  function filterRawData(rawData, filters, category) {
    var optimizedFilters = optimizeFilters(filters);
    function filterOut(item) {
      var result = true;
      _.forEach(optimizedFilters, function (filter, property) {
        result = result && filterByProperty(item, filter, property);
      });
      return result;
    }
    if (category === 'detailsPanel') {
      return _.chain(rawData).filter(filterOut).value();
    } else {
      return _.chain(rawData).filter({
        category: category
      }).filter(filterOut).value();
    }
  }
  return {
    filterRawData: filterRawData
  };
};
RecommendationFilterService.$inject = ['FaresOptimizerConstants'];
module.exports = RecommendationFilterService;